import { Redirect, generatePath, useParams } from 'react-router-dom'
import { Message } from 'semantic-ui-react'
import { useDispatch } from 'react-redux'

import { useQuery } from '@cbgms/base/http/use-query'
import { getShop } from 'app-support/shops/state/actions'

interface RouteParams {
  shopID: string
  tab: string
}

export function ShopIDToCompanyRedirect() {
  const dispatch = useDispatch()
  const { shopID, tab } = useParams<RouteParams>()

  const shop = useQuery(['ShopIDToCompanyRedirect', 'getShop', shopID], async () => {
    const { Data } = await dispatch(getShop(shopID))

    return Data
  })

  if (shop.isLoading || !shop.data) return null
  if (shop.isError) return <Message error content='Failed to load shop unable to redirect.' header='Error' />

  const path = generatePath('/companies/:companyUUID/shops/edit/:shopID', {
    companyUUID: shop.data.CompanyUUID,
    shopID
  })

  return <Redirect to={{ hash: tab, pathname: path }} />
}
